export const confirmActions = (obj) => {
    return { type: "DELETE", obj };
};